import { spawnYesNoDialog } from "$root/components/spawnable/yes-no-dialog";
import { Text } from "@mdotm/shadcn/legacy/components";

export function spawnDeleteCustomAttributeDialog(): Promise<boolean> {
	return spawnYesNoDialog({
		size: "medium",
		header: "Are you sure you want to delete this custom property?",
		yesButton: "Proceed",
		noButton: "Cancel",
		children: (
			<div className="flex flex-col gap-3">
				<Text type="Body/L/Book" as="p">
					This property will be deleted at the customer level —{" "}
					<strong>all users under this customer will lose access to it.</strong>
				</Text>
				<Text type="Body/L/Book" as="p">
					This action will affect tables, charts, and filters using it.
				</Text>
			</div>
		),
	});
}

export function spawnDeleteSharedConceptDialog(): Promise<boolean> {
	return spawnYesNoDialog({
		size: "medium",
		header: "Are you sure you want to delete this property?",
		yesButton: "Proceed",
		noButton: "Cancel",
		children: (
			<>
				<Text type="Body/L/Book">
					This property will be deleted <strong>from all your workspaces.</strong>
				</Text>
				<Text type="Body/L/Book" as="p">
					This action will affect tables, charts, and filters using it.
				</Text>
			</>
		),
	});
}
